import type { SxStyle } from '@aibees/shared/theme';

export const textField: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const rhfInput: SxStyle = {
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: (p) => p.palette.primary[500],
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
      borderColor: (p) => p.palette.primary[500],
    },
  },
};
